import {throwError} from "./util";

let gOffsetBase: HTMLElement;

export function mountHTML(selector: string, dom: Element) {
    let root = (document.querySelector(selector) as HTMLElement);
    while (root.firstChild) {
        root.removeChild(root.firstChild);
    }
    root.appendChild(dom);
}

export type BBox = ReturnType<typeof bboxAbsolute>

export function bboxAbsolute(el: Element) {
    let
        found,
        left = 0,
        top = 0,
        width = 0,
        height = 0,
        offsetBase = gOffsetBase;
    if (!offsetBase && document.body) {
        offsetBase = gOffsetBase = document.createElement("div");
        offsetBase.style.cssText = "position:absolute;left:0;top:0";
        document.body.appendChild(offsetBase);
    }
    if (el && el.ownerDocument === document && "getBoundingClientRect" in el && offsetBase) {
        const boundingRect = el.getBoundingClientRect();
        const baseRect = offsetBase.getBoundingClientRect();
        found = true;
        left = boundingRect.left - baseRect.left;
        top = boundingRect.top - baseRect.top;
        width = boundingRect.right - boundingRect.left;
        height = boundingRect.bottom - boundingRect.top;
    }
    return {
        found: found,
        left: left,
        top: top,
        width: width,
        height: height,
        right: left + width,
        bottom: top + height,
    };
}

/** Computes the top,left of an element relative to its parent position:relative. */
export function bboxRelativeToPosition(el: HTMLElement) {
    let dom = el,
        computed: CSSStyleDeclaration = undefined as any;
    do {
        dom = dom.offsetParent as HTMLElement;
        computed = window.getComputedStyle(dom);
    }
    while (dom && computed.position !== "relative");
    const bboxRel = dom.getBoundingClientRect();
    const bboxEl = el.getBoundingClientRect();
    return {
        top: bboxEl.top - bboxRel.top,
        left: bboxEl.left - bboxRel.left,
        width: bboxEl.width,
        height: bboxEl.height,
    };
}

type DelegateEventCallback<T> = (ev: HTMLElement, uid?: T) => void
type EventCallbacks<T> = {
    [key in keyof HTMLElementEventMap]: DelegateEventCallback<T>
}

export function delegateEvent<T>(parent: HTMLElement,
                                 childTag: string | [string, string],
                                 events: Partial<EventCallbacks<T>>): void;
export function delegateEvent<T>(parent: HTMLElement,
                                 childTag: string | [string, string],
                                 events: Partial<EventCallbacks<T>>,
                                 marker: ((e: HTMLElement, i: number) => void) | T[]): void;
export function delegateEvent<T>(parent: HTMLElement,
                                 childTag: string | [string, string],
                                 events: Partial<EventCallbacks<T>>,
                                 marker?: ((e: HTMLElement, i: number) => void) | T[]): void {
    addElementMarkers();

    for (const it of Object.keys(events) as (keyof (typeof events))[]) {
        const cb = events[it]!;
        parent.addEventListener(it, onCapture(it, cb), true);
    }

    function onCapture(type: string, callback: DelegateEventCallback<T>) {
        return function(this: HTMLElement, ev: Event): void {
            if (!ev.target) return;
            const elem = ev.target as HTMLElement & { $$uid: T };
            const isChildElement = typeof childTag === "string" ? elem.tagName === childTag :
                                   elem.tagName === childTag[0] && elem.classList.contains(childTag[1]);

            if (type === "drop") console.log("elem", elem, isChildElement, childTag);
            if (isChildElement) {
                callback(elem, elem.$$uid);
                ev.stopPropagation();
                ev.preventDefault();
            }
        };
    }

    function addElementMarkers() {
        if (!marker) return;

        // Append unique id to the elements we want to listen for
        const searchTag = typeof childTag === "string" ? childTag : childTag[0];
        const children: HTMLElement[] = Array.from(parent.querySelectorAll(searchTag));
        for (let i = 0; i < children.length; i++) {
            let it = children[i];
            if (typeof childTag !== "string" && !it.classList.contains(childTag[1])) continue;

            if (typeof marker === "function") {
                marker(it, i);
            }
            else if (Array.isArray(marker)) {
                (it as any).$$uid = marker[i];
            }
            else {
                throw throwError("marker is unknown type", marker);
            }
        }
    }
}
